import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import PageLoader from './components/PageLoader'
import { Toaster } from '@/components/ui/sonner'
import { RouterProvider } from 'react-router-dom'
import ModalProvider from './components/ModalProvider'
import { BugReportProvider } from './components/bug-report/BugReportProvider'
import './index.css'
import './posthog-config'
import '@tldraw/tldraw/tldraw.css'
import { ThemeProvider } from 'next-themes'
import { I18nProvider } from './i18n'
import './i18n/config'
import { initErrorCapture } from './utils/bugReportDiagnostics'
import { router } from './routerConfig'

;(window as unknown as { __APP_BUILD?: string }).__APP_BUILD = '0.1.35'

initErrorCapture()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Dark mode: default is light, user choice persists in localStorage under intuigence-theme */}
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="intuigence-theme">
      <I18nProvider>
        <AppErrorBoundary>
          <BugReportProvider>
            <PageLoader />
            <RouterProvider router={router} />
            <Toaster position="bottom-center" />
            <ModalProvider />
          </BugReportProvider>
        </AppErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  </React.StrictMode>
)
// trigger frontend image build 2026-03-23
